module.exports = __webpack_public_path__ + "media/images/video-story-placeholder-default-61497285b1fe6900ff1da0b218270ac5.png";